import React from 'react'
import { View, Platform, TouchableOpacity, ViewStyle } from 'react-native'
import { Text } from '../text'
import { Medal } from '../medal'
import { SvgXml } from 'react-native-svg'
import { RecallWheel } from '../recall-wheel'
import { useTranslation } from 'react-i18next'
const _snakeCase = require('lodash/snakeCase')

interface HistoryRowProps {
  title: string
  date: string
  correct: number
  total: number
  medal: string | null
  onPress: () => void
  reinforcement?: boolean
  enterpriseTier?: boolean
}

export const HistoryRow = (props: HistoryRowProps) => {
  const {
    title,
    date,
    correct,
    reinforcement,
    total,
    medal,
    onPress,
    enterpriseTier = false,
  } = props
  const earnedDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })

  const renderIcon = () => {
    if (!enterpriseTier) {
      return (
        <View style={{ alignSelf: 'flex-end', height: 32, width: 32, marginRight: 5 }}>
          <RecallWheel
            style={{ alignSelf: 'flex-end' }}
            variant="medium-small"
            icon="gradient_check"
            value={correct / total}
            circleColour="rgb(129, 52, 254)"
            iconColour="rgb(129, 52, 254)"
            strokeColor="rgb(216, 202, 254)"
          />
        </View>
      )
    } else {
      return title.toLocaleLowerCase().includes('pre-test') ||
        title.toLocaleLowerCase().includes('post-test') ? (
        Platform.OS === 'web' ? (
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            style={{ marginRight: 18, paddingLeft: 4 }}
            fill="none"
          >
            <path
              d="M0.0166016 14.0563C0.0166016 6.31115 6.30303 0.0324707 14.0482 0.0324707V0.0324707C21.7933 0.0324707 28.0797 6.31115 28.0797 14.0563V14.0563C28.0797 21.8014 21.7933 28.0801 14.0482 28.0801V28.0801C6.30303 28.0801 0.0166016 21.8014 0.0166016 14.0563V14.0563Z"
              fill="white"
            />
            <path
              d="M14.0482 26.5801C7.13038 26.5801 1.5166 20.9719 1.5166 14.0563C1.5166 7.14065 7.13038 1.53247 14.0482 1.53247C20.966 1.53247 26.5797 7.14065 26.5797 14.0563C26.5797 20.9719 20.966 26.5801 14.0482 26.5801Z"
              stroke="black"
              stroke-opacity="0.1"
              stroke-width="3"
            />
            <path
              d="M3.29419 14.2285C3.29419 8.19747 8.18934 3.30835 14.2204 3.30835V3.30835V3.30835C20.2514 3.30835 25.1466 8.19747 25.1466 14.2285V14.2285C25.1466 20.2595 20.2514 25.1486 14.2204 25.1486V25.1486C8.18934 25.1486 3.29419 20.2595 3.29419 14.2285V14.2285Z"
              fill="white"
            />
            <path
              d="M12.4099 16.2536L18.5977 10.0296C19.0082 9.61677 19.6817 9.61677 20.0921 10.0296C20.5025 10.4424 20.5025 11.1093 20.0921 11.5221L13.1571 18.4976C12.7467 18.9104 12.0837 18.9104 11.6733 18.4976L8.9477 15.7561C8.53729 15.3433 8.53729 14.6764 8.9477 14.2636C9.35812 13.8508 10.0211 13.8508 10.4315 14.2636L12.4099 16.2536Z"
              fill="#666666"
            />
          </svg>
        ) : (
          <View style={{ marginRight: 16, paddingLeft: 2 }}>
            <SvgXml
              xml={`<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.0166016 14.0563C0.0166016 6.31115 6.30303 0.0324707 14.0482 0.0324707V0.0324707C21.7933 0.0324707 28.0797 6.31115 28.0797 14.0563V14.0563C28.0797 21.8014 21.7933 28.0801 14.0482 28.0801V28.0801C6.30303 28.0801 0.0166016 21.8014 0.0166016 14.0563V14.0563Z" fill="white"/>
                <path d="M14.0482 26.5801C7.13038 26.5801 1.5166 20.9719 1.5166 14.0563C1.5166 7.14065 7.13038 1.53247 14.0482 1.53247C20.966 1.53247 26.5797 7.14065 26.5797 14.0563C26.5797 20.9719 20.966 26.5801 14.0482 26.5801Z" stroke="black" stroke-opacity="0.1" stroke-width="3"/>
                <path d="M3.29419 14.2285C3.29419 8.19747 8.18934 3.30835 14.2204 3.30835V3.30835V3.30835C20.2514 3.30835 25.1466 8.19747 25.1466 14.2285V14.2285C25.1466 20.2595 20.2514 25.1486 14.2204 25.1486V25.1486C8.18934 25.1486 3.29419 20.2595 3.29419 14.2285V14.2285Z" fill="white"/>
                <path d="M12.4099 16.2536L18.5977 10.0296C19.0082 9.61677 19.6817 9.61677 20.0921 10.0296C20.5025 10.4424 20.5025 11.1093 20.0921 11.5221L13.1571 18.4976C12.7467 18.9104 12.0837 18.9104 11.6733 18.4976L8.9477 15.7561C8.53729 15.3433 8.53729 14.6764 8.9477 14.2636C9.35812 13.8508 10.0211 13.8508 10.4315 14.2636L12.4099 16.2536Z" fill="#666666"/>
                </svg>
              `}
            />
          </View>
        )
      ) : (
        <Medal style={{ marginRight: 14 }} hideRecall={medal !== null} level={medal} size={32} />
      )
    }
  }

  const { t } = useTranslation()
  const levelTx = t(`Certifications.${medal?.toLowerCase()}`)

  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={{ qat: `result_${_snakeCase(title)}_btn` }}
      onPress={onPress}
      style={ROOT}
    >
      {renderIcon()}
      <View style={{ flexDirection: 'column', flex: 1 }}>
        <Text
          style={{ width: '100%' }}
          disableLink
          numberOfLines={1}
          txOptions={{ quiz: title, medal: levelTx }}
          tx={
            !enterpriseTier
              ? 'Certifications.notEarnedHistory'
              : reinforcement
                ? 'Certifications.reinforcementHistory'
                : medal
                  ? 'Certifications.earnedHistory'
                  : 'Certifications.notEarnedHistory'
          }
          variant="body1"
        />
        <Text
          variant="body2"
          tx="Quiz.historySubtitle"
          style={{ color: 'rgb(96, 101, 104)' }}
          txOptions={{ correct, total, date: earnedDate ?? '' }}
        />
      </View>
    </TouchableOpacity>
  )
}

const ROOT: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  height: 36,
  marginBottom: 16,
}
